import { owaspAsiToDisplayName } from 'src/app/common/violationRulesUtils';
import { FilterTypesEnum } from '../filters/filterTypes.enum';
import { ISelectOption } from './selectOption.interface';

export const OwaspAsiSelectOptionAll: ISelectOption = {
  id: `${FilterTypesEnum.OwaspAsi.toString()}-all`,
  value: 'all',
  displayName: 'All',
  filterType: FilterTypesEnum.OwaspAsi,
  categoryName: FilterTypesEnum.OwaspAsi.toString(),
};

export const OwaspAsiSelectOptions: ISelectOption[] = Object.keys(owaspAsiToDisplayName).map(
  (attackKey) =>
    ({
      id: `${FilterTypesEnum.OwaspAsi.toString()}-${attackKey}`,
      value: attackKey,
      displayName: owaspAsiToDisplayName[attackKey],
      filterType: FilterTypesEnum.OwaspAsi,
      categoryName: FilterTypesEnum.OwaspAsi.toString(),
    }) as ISelectOption
);
